import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import { startAppUpdateChecker } from '@/lib/appUpdate.js'
import '@/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)

if (import.meta.env.PROD) startAppUpdateChecker()
